import { Fragment, useMemo, useState } from 'react';
import { Page } from '../theme/elements/Page';
import { Button, DialogActions, Stack, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { FormButton } from 'theme/elements/Buttons';
import { pendingRequestsTypes } from 'constants/requests.constants';

interface Iprops {
	loading?: boolean;
	handleApprove: any;
	approveDisabled?: boolean;
	handleReject?: any;
	handleCancel?: any;
	approveLabel?: string;
	cancelLabel?: string;
	disabledApprove?: boolean;
	disabledReject?: boolean;
	disabledCancel?: boolean;
	handleDecline?: boolean;
}

export const ApproveFormButtons = (props: Iprops) => {
	const {
		loading = false,
		handleApprove,
		handleReject,
		approveLabel,
		handleCancel,
		cancelLabel,
		disabledApprove = false,
		disabledReject = false,
		disabledCancel = false,
		handleDecline = false,
	} = props;
	const t = useAppSelector(selectTranslations);
	const navigate = useNavigate();

	return (
		<Stack direction="row" justifyContent="space-between" width="100%">
			<FormButton>
				<Button
					onClick={() => {
						if (handleCancel) {
							handleCancel();
						} else {
							navigate(-1);
						}
					}}
					disabled={loading || disabledCancel}
					variant="outlined"
				>
					{cancelLabel || t('button.cancel')}
				</Button>
			</FormButton>
			<FormButton>
				<Stack direction="row" gap={2}>
					{handleDecline && (
						<Button
							variant="contained"
							disabled={loading || disabledReject}
							onClick={() => {
								//dispatch here decline
								if (handleReject) {
									handleReject(true);
								}
							}}
						>
							{t('label.RejectRequest')}
						</Button>
					)}
					<Button
						variant="contained"
						disabled={loading || disabledReject}
						onClick={() => {
							//dispatch here decline
							if (handleReject) {
								handleReject();
							}
						}}
					>
						{t('label.DeclineRequest')}
					</Button>
					<Button
						variant="contained"
						disabled={loading || disabledApprove}
						onClick={() => {
							//dispatch here approve
							handleApprove('approve');
						}}
					>
						{approveLabel ? t(approveLabel) : t('label.ApproveRequest')}
					</Button>
				</Stack>
			</FormButton>
		</Stack>
	);
};

export const ApproveDialogButtons = (props: Iprops) => {
	const { handleApprove, handleReject, approveDisabled, approveLabel, cancelLabel } = props;
	const t = useAppSelector(selectTranslations);
	const navigate = useNavigate();

	return (
		<DialogActions>
			<Stack direction="row" justifyContent="space-between" width="100%">
				<FormButton>
					<Button
						onClick={() => {
							if (handleReject) {
								handleReject();
							}
						}}
						variant="outlined"
					>
						{cancelLabel || t('button.cancel')}
					</Button>
				</FormButton>
				<FormButton>
					<Button
						onClick={() => {
							handleApprove();
						}}
						variant="contained"
						disabled={approveDisabled}
					>
						{approveLabel ? t(approveLabel) : t('button.ok')}
					</Button>
				</FormButton>
			</Stack>
		</DialogActions>
	);
};
